<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <global-table
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :table-data="getData"
          :total-data="totalRows"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="customerForm"
          :redirect-detail="true"
          :show-add-button="accessLevel"
          :search-by-customer-group="true"
          caption="<i class='fa fa-align-justify'></i> Customer Listing"
          addButton="Tambah Customer"
          @editForm="editForm"
          @resetForm="resetForm"
        ></global-table>
      </b-col>

      <b-modal
        ref="myModalRef"
        id="addModals"
        header-border-variant="no-border text-center"
        footer-border-variant="no-border"
        footer-bg-variant="light"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        hide-footer
        size="lg"
      >
        <div slot="modal-header" class="text-center">
          <h3 class="text-center">Input Konsumen Baru</h3>
        </div>

        <div v-if="!loadingSubmit">
          <b-form id="customerForm" validated novalidate @submit="submitAdd">
            <b-row>
              <b-col sm="3">
                <b-form-group label-for="name" label="Nama Konsumen">
                  <b-form-input
                    id="name"
                    type="text"
                    v-model="$v.customerForm.name.$model"
                    :state="!$v.customerForm.name.$invalid"
                    required
                    placeholder="Nama Konsumen"
                  ></b-form-input>
                  <b-form-invalid-feedback>Nama Konsumen harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group label-for="customer_group" label="Group Konsumen">
                  <model-select
                    id="customer_group"
                    :options="listCustomerGroup"
                    v-model="$v.customerForm.customer_group.$model"
                    :isError="$v.customerForm.customer_group.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                    @input="setSelected"
                  ></model-select>
                  <div
                    v-if="customerForm.customer_group === null"
                    class="invalid-feedback-custom"
                  >Group konsumen harus di isi.</div>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group label-for="vehicle_delivery_id" label="Kendaraan yang mengirim">
                  <model-select
                    id="vehicle_delivery_id"
                    :options="listVehicleDelivery"
                    v-model="$v.customerForm.vehicle_delivery_id.$model"
                    :isError="$v.customerForm.vehicle_delivery_id.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>
                  <div
                    v-if="customerForm.vehicle_delivery_id === null"
                    class="invalid-feedback-custom"
                  >Kendaraan yang mengirim harus di isi.</div>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group label-for="owner_name" label="Nama Pemilik">
                  <b-form-input
                    id="owner_name"
                    type="text"
                    v-model="$v.customerForm.owner_name.$model"
                    :state="!$v.customerForm.owner_name.$invalid"
                    required
                    placeholder="Nama Pemilik"
                  ></b-form-input>
                  <b-form-invalid-feedback>Nama pemilik harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="3">
                  <b-form-group label-for="province" label="Provinsi">
                    <model-select
                      id="province"
                      :options="listProvince"
                      v-model="$v.customerForm.province.$model"
                        @input="filterRegency"
                      :isError="$v.customerForm.province.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="customerForm.province === null"
                      class="invalid-feedback-custom"
                    >Provinsi harus di isi.</div>
                  </b-form-group>
                </b-col>
                 <b-col sm="3">
                  <b-form-group label-for="regencies" label="Regensi">
                    <model-select
                      id="regencies"
                      :options="listRegencies"
                      v-model="$v.customerForm.regencies.$model"
                      @input="filterDistrict"
                      :isError="$v.customerForm.regencies.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="customerForm.regencies === null"
                      class="invalid-feedback-custom"
                    >Regensi harus di isi.</div>
                  </b-form-group>
                </b-col>

                <b-col sm="3">
                  <b-form-group label-for="district" label="Distrik">
                    <model-select
                      id="district"
                      :options="listDistrict"
                      v-model="$v.customerForm.district.$model"
                      @input="filterVillage($event)"
                      :isError="$v.customerForm.district.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="customerForm.district === null"
                      class="invalid-feedback-custom"
                    >Distrik harus di isi.</div>
                  </b-form-group>
                </b-col>
                
                <b-col sm="3">
                  <b-form-group label-for="village" label="Kampung">
                    <model-select
                      id="village"
                      :options="listVillage"
                      v-model="$v.customerForm.villages.$model"
                      :isError="$v.customerForm.villages.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    
                    <div
                      v-if="customerForm.villages === null"
                      class="invalid-feedback-custom"
                    >Kampung harus di isi.</div>
                  </b-form-group>
                </b-col>
            </b-row>

            <b-row>
               <b-col sm="3">
                <b-form-group label-for="zone" label="Kode Sub Zona">
                  <model-select
                    id="zone"
                    :options="listZone"
                    v-model="$v.customerForm.zone.$model"
                    :isError="$v.customerForm.zone.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>
                  <div
                    v-if="customerForm.zone === null"
                    class="invalid-feedback-custom"
                  >Zona harus di isi.</div>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group label-for="order_time_id" label="Waktu Pemesanan">
                  <model-select
                    id="order_time_id"
                    :options="listOrderTime"
                    v-model="$v.customerForm.order_time_id.$model"
                    :isError="$v.customerForm.order_time_id.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>
                  <div
                    v-if="customerForm.order_time_id === null"
                    class="invalid-feedback-custom"
                  >Waktu pemesanan harus di isi.</div>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group label-for="lat" label="Lat">
                  <b-form-input
                    id="lat"
                    type="text"
                    v-model="$v.customerForm.lat.$model"
                    :state="!$v.customerForm.lat.$invalid"
                    required
                    placeholder="Latitude"
                  ></b-form-input>
                  <b-form-invalid-feedback>Latitude harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group label-for="lng" label="Lng">
                  <b-form-input
                    id="lng"
                    type="text"
                    v-model="$v.customerForm.lng.$model"
                    :state="!$v.customerForm.lng.$invalid"
                    required
                    placeholder="Longitude"
                  ></b-form-input>
                  <b-form-invalid-feedback>Longitude harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="3">
                <b-form-group label-for="mobile_phone" label="No HP">
                  <b-form-input
                    id="mobile_phone"
                    type="text"
                    v-model="$v.customerForm.mobile_phone.$model"
                    :state="!$v.customerForm.mobile_phone.$invalid"
                    required
                    placeholder="No HP"
                  ></b-form-input>
                  <b-form-invalid-feedback>No HP harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group label-for="mobile_phone2" label="No HP-2">
                  <b-form-input
                    id="mobile_phone2"
                    type="text"
                    v-model="$v.customerForm.mobile_phone2.$model"
                    :state="!$v.customerForm.mobile_phone2.$invalid"
                    placeholder="No HP-2"
                  ></b-form-input>
                  <b-form-invalid-feedback>No HP 2 harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group label-for="mobile_phone3" label="No WA">
                  <b-form-input
                    id="mobile_phone3"
                    type="text"
                    v-model="$v.customerForm.mobile_phone3.$model"
                    :state="!$v.customerForm.mobile_phone3.$invalid"
                    placeholder="No HP WA"
                  ></b-form-input>
                  <b-form-invalid-feedback>No WA harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group label-for="bank_account_name" label="Nama Rekening">
                  <b-form-input
                    id="bank_account_name"
                    type="text"
                    v-model="$v.customerForm.bank_account_name.$model"
                    :state="!$v.customerForm.bank_account_name.$invalid"
                    placeholder="Nama Rekening"
                  ></b-form-input>
                  <b-form-invalid-feedback>Nama Rekening harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            
            <b-row>
               <b-col sm="3">
                <b-form-group label-for="bank_account_number" label="Nomor Rekening">
                  <b-form-input
                    id="bank_account_number"
                    type="text"
                    v-model="$v.customerForm.bank_account_number.$model"
                    :state="!$v.customerForm.bank_account_number.$invalid"
                    placeholder="Nomor Rekening"
                  ></b-form-input>
                  <b-form-invalid-feedback>Nomor Rekening harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
                <b-col sm="3">
                  <b-form-group label-for="nomor_ktp" label="Nomor Induk Kependudukan">
                    <b-form-input
                      id="nomor_ktp"
                      type="text"
                      v-model="$v.customerForm.ktp_number.$model"
                      :state="!$v.customerForm.ktp_number.$invalid"
                      required
                      placeholder="Nomor Induk Kependudukan"
                    ></b-form-input>
                    <b-form-invalid-feedback>Nomor Induk Kependudukan harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <b-col sm="6">
                  <b-form-group label-for="address_ktp" label="Alamat KTP">
                    <b-form-textarea
                      id="address_ktp"
                      :rows="3"
                      :max-rows="6"
                      v-model="$v.customerForm.address_ktp.$model"
                      :state="!$v.customerForm.address_ktp.$invalid"
                      required
                    ></b-form-textarea>
                    <b-form-invalid-feedback>Alamat harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
            </b-row>    


            <div class="float-right">
              <b-button type="button" size="sm" variant="danger" @click="cancelAdd">
                <i class="fa fa-undo"></i> Back
              </b-button>&nbsp;
              <b-button
                type="submit"
                size="sm"
                variant="primary"
                :disabled="$v.customerForm.$invalid"
              >
                <i class="fa fa-save"></i> Save
              </b-button>
            </div>
          </b-form>
        </div>

        <div v-else>
          <loading></loading>
        </div>
      </b-modal>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "../../templates/TableNew.vue";
import interfaces from "@/templates/_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import * as moment from "moment";
import "moment/locale/id";
import { ModelSelect } from "vue-search-select";
import custom_validation from "@/templates/_customValidation.js";
import loading from "@/templates/Loading.vue";

export default {
  name: "customer",
  components: { globalTable, ModelSelect, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      customer: [],
      listCustomerGroup: [],
      listZone: [],
      listVehicleDelivery: [],
      listOrderTime: [],
      listProvince: [],
      listRegencies: [],
      listDistrict: [],
      listVillage: [],
      loading: true,
      loadingSubmit: false,
      totalRows: "",
      isNonGT: false,
      fields: [
        { key: "customer_detail", label: "Nama Outlet", sortable: true, filterByFormatted: true },
        { key: "owner_name", label: "Pemilik", sortable: true, filterByFormatted: true },
        { key: "contact_number", label: "Nomor Kontak", sortable: false, filterByFormatted: true },
        {
          key: "vehicle_delivery_name",
          label: "Kendaraan Yang Mengirim",
          sortable: false, filterByFormatted: true
        },
        { key: "zone", label: "Zona", sortable: false, filterByFormatted: true },
        { key: "order_time_routine_name", label: "Hari Order", sortable: false, filterByFormatted: true },
        { key: "dc_name", label: "Distribution Center", sortable: false, filterByFormatted: true },
        { key: "bank_account", label: "Bank Account", sortable: false, filterByFormatted: true },
        { key: "leads_info", label: "Lead Information", sortable: false, filterByFormatted: true },
        { key: "action", class: "text-center width-80" }
      ],
      customerForm: interfaces.customer
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  validations() {
    if (this.isNonGT === true) {
      return custom_validation.customer.true;
    } else {
      return custom_validation.customer.false;
    }
  },
  computed: {
    accessLevel() {
      let employee_id = localStorage.getItem("nik");
      return localStorage.getItem("level") === "1" || (['MBS22090004'].includes(employee_id)) ? true : false;
    }
  },
  methods: {
    getData: function(ctx) {
      this.loading = true;
      let response = axios.post('web/customer/all', ctx);
      return response.then((data) => {
        const items = data.data.data;
        this.totalRows = data.data.total_rows;
        this.loading=false;
        return(items)
      }).catch(error => {
        this.expired(error);
        this.loading=false;
        return []
      })
    },
    init: function() {
     // this.loading = true;
      //this.getAllCustomer();
      this.getDropdown();
    },
    setSelected: function(event) {
      let temp = this.listCustomerGroup.filter(x=>x.value === event);
      this.isNonGT = (temp[0].flag === '2') ? true : false;
    },
    // getAllCustomer: function() {
    //   this.axios
    //     .get("web/customer/all/")
    //     .then(response => {
    //       this.customer = response.data.data;
    //     })
    //     .catch(error => {})
    //     .finally(() => {
    //       this.loading = false;
    //     });
    // },
    getDropdown: function() {
      this.axios
        .get("web/dropdown/dropdown-customer/")
        .then(response => {
          this.listCustomerGroup = response.data.customer_group;
          this.listZone = response.data.zone;
          this.listOrderTime = response.data.order_time;
          this.listVehicleDelivery = response.data.vehicle_delivery;
          this.listProvince = response.data.province;
        })
        .catch(error => {})
        .finally(() => {});
    },
     filterRegency: function(){
      this.customerForm.regencies = null;
      this.customerForm.district = null;
      this.customerForm.villages = null;
      this.listRegencies = [];
      this.listDistrict = [];
      this.listVillage = [];
      this.axios.get("/web/dropdown/regency/" + this.customerForm.province)
      .then((response) => {
        this.listRegencies = response.data.data;
      });
    },
    filterDistrict: function(){
      this.customerForm.district = null;
      this.customerForm.villages = null;
      this.listDistrict = [];
      this.listVillage = [];
      this.customerForm.zone = null;
      this.axios.get("/web/dropdown/district/" + this.customerForm.regencies)
      .then((response) => {
        this.listDistrict = response.data.data;
      });
    },
    filterVillage: function(event){
      this.customerForm.villages = null;
      this.listVillage = [];
      this.axios.get("/web/dropdown/village/" + this.customerForm.district)
      .then((response) => {
        this.listVillage = response.data.data;
        this.customerForm.zone = response.data.zone;
      });
    },
    editForm: function() {},
    resetForm: function() {
      for (var a in interfaces.customer) {
        interfaces.customer[a] = null;
      }
      this.customerForm = interfaces.customer;
    },
    cancelAdd: function() {
      this.$refs.myModalRef.hide();
    },
    submitAdd: function(evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin menambahkan konsumen baru ?")) {
        this.loadingSubmit = true;
        let customer = this.customerForm;
        this.axios
          .post("web/customer/add/", customer)
          .then(response => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Tambah Konsumen",
                message: response.data.message
              });
              this.$router.push({ path: "all/detail/" + response.data.id });
            }
          })
          .catch(error => {
            this.expired(error);
          })
          .finally(() => {
            this.loadingSubmit = false;
          });
      }
    },
    expired: function(error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: "Tambah Konsumen",
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style>
</style>
